**Deprecated:** This is always `null` and has been replaced by Optimised Apply.
